export const OFFER_PARAMS = [
  'amount',
  'emd',
  'inspectionDays',
  'daysToClose',
  'titleCompanyName',
  'inspectionMode',
  'estimatedProceeds',
];

export const POSSIBLE_ACTIONS = {
  OFFER: 'offer',
  REJECTED_BY_BUYER: 'rejected_by_buyer',
  FIRM_ON_OFFER: 'firm_on_offer',
};

export const HOMEWARD_ID = '613bb6dd0ceb620e2c4d3a73';
